import { compilePath } from '../../../../utils/paths'
import { LEGAL_FORM_VALUES } from '../constants'

import {
  APPLY_DOCUMMENTS_INFO_PATH,
  APPLY_DOCUMMENTS_UPLOAD_PATH
} from '../../../MainRoutes/constants'

export const compileDocInfoPath = compilePath(APPLY_DOCUMMENTS_INFO_PATH)
export const compileDocUploadPath = compilePath(APPLY_DOCUMMENTS_UPLOAD_PATH)

const CANARIAN_ZIP_STARTS = ['35', '38']
export const isCanarian = zipCode => CANARIAN_ZIP_STARTS.some(
  canarian => {
    const code = zipCode.length === 4 ? `0${zipCode}` : zipCode
    return code.startsWith(canarian)
  }
)

export const legalFormsMustDeclareModel200 = [
  LEGAL_FORM_VALUES.SL,
  LEGAL_FORM_VALUES.SA,
  LEGAL_FORM_VALUES.UTE,
  LEGAL_FORM_VALUES.AIE,
  LEGAL_FORM_VALUES.COOPERATIVE,
  LEGAL_FORM_VALUES.SAT
]

export const legalFormsQuestDeclareModel200 = [
  LEGAL_FORM_VALUES.FUNDATION,
  LEGAL_FORM_VALUES.ASSOCIATION,
  LEGAL_FORM_VALUES.CONGREGATIONS,
  LEGAL_FORM_VALUES.OTHERS
]

export const getRequireModel200Default = application => legalFormsMustDeclareModel200
  .includes(application.data.legal_form)

export const legalFormsQuestAuditory = [
  LEGAL_FORM_VALUES.SL,
  LEGAL_FORM_VALUES.SA,
  LEGAL_FORM_VALUES.UTE,
  LEGAL_FORM_VALUES.AIE,
  LEGAL_FORM_VALUES.COOPERATIVE,
  LEGAL_FORM_VALUES.SAT,
  LEGAL_FORM_VALUES.FUNDATION,
  LEGAL_FORM_VALUES.ASSOCIATION,
  LEGAL_FORM_VALUES.CONGREGATIONS,
  LEGAL_FORM_VALUES.OTHERS
]

export const legalFormQuestPeriodTax = [
  LEGAL_FORM_VALUES.SL,
  LEGAL_FORM_VALUES.SA,
  LEGAL_FORM_VALUES.UTE,
  LEGAL_FORM_VALUES.AIE,
  LEGAL_FORM_VALUES.COOPERATIVE,
  LEGAL_FORM_VALUES.SAT,
  LEGAL_FORM_VALUES.FREELANCE,
  LEGAL_FORM_VALUES.CIVIL,
  LEGAL_FORM_VALUES.COMMUNITIES_GOODS
]
